import { useTranslation } from 'react-i18next'
import { Design } from '../../../core/models/entities/Design'
import { DesignStatus } from '../../../core/models/entities/enums/DesignStatus'
import { ApprovalDisplay, ApprovalListDisplay } from '../Approval/ApprovalDisplay'

export function DesignStatusElement({ design }: { design: Design }) {
  const { t } = useTranslation()
  switch (design.status) {
    case DesignStatus.Unknown:
      return <p className={`mb-1 font-semibold text-xs text-gray-600`}>{t("compLogoDesign.statusUnknown")}</p>
    case DesignStatus.Draft:
      return <p className={`mb-1 font-semibold text-xs text-orange-400`}>{t("compLogoDesign.statusDraft")}</p>
    case DesignStatus.Rejected:
      return <ApprovalDisplay approval={design.approval!} />
    case DesignStatus.Approval:
      return <ApprovalDisplay approval={design.approval!} />
    case DesignStatus.Done:
      return <ApprovalListDisplay approval={design.approval!} />
  }
}
